import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '@app/shared';
import { LinqFormsModule } from '@app/shared/forms/forms.module';
import { RelatedVendorsComponent } from './components/related-vendors/related-vendors.component';
import { VendorAddNewComponent } from './components/vendor-add-new/vendor-add-new.component';
import { VendorService } from './services/vendor.service';

const components = [VendorAddNewComponent, RelatedVendorsComponent];

@NgModule({
    imports: [CommonModule, SharedModule, LinqFormsModule, ...components],
    providers: [VendorService],
    exports: [...components],
})
export class VendorsModule {}
